import {
  type OrderGetOrderDetailsOrderItemReadDto,
  type OrderItemDetailsReadDto,
} from "@/config/apiClient";

// TODO
// There is no link between dispatch address and organisation address
// We have to check for equal value between them to check
// Not ideal, can be improve

export const getUniqueAddressesFromOrderItem = (
  orderItem: OrderGetOrderDetailsOrderItemReadDto | OrderItemDetailsReadDto
) => {
  // Declare array of unique addresses
  const addresses: OrderItemDetailsReadDto["sandboxItem"]["SandboxItemVersion"][number]["SandboxItemVersionDispatch"] =
    [];

  // Get all dispatches
  const versionsDispatches = orderItem.sandboxItem.SandboxItemVersion.map(
    (version) => version.SandboxItemVersionDispatch
  );

  // Map dispatches
  versionsDispatches?.flat()?.forEach((address) => {
    const { quantity: _quantity, ...rest } = address;

    // If address not already in addresses array
    if (
      !addresses.find(
        (add) =>
          add.address === address.address &&
          add.postalCode === address.postalCode &&
          add.recipientName === address.recipientName
      )
    ) {
      // Calculate total quantity for this address
      const totalQuantity = versionsDispatches
        .flat()
        .filter(
          (add) =>
            add.address === address.address &&
            add.postalCode === address.postalCode &&
            add.recipientName === address.recipientName
        )
        .reduce((sum, add) => sum + add.quantity, 0);

      // Add this address with total quantity to the addresses array to return
      addresses.push({ quantity: totalQuantity, ...rest });
    }
  });

  return addresses;
};
